// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.faq-container {
  width: 100%;
  color: black;
}

/* Banner */
.faq-banner {
  position: relative;
  height: 220px;
  overflow: hidden;
}

.faq-banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(55%);
}

.faq-banner-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  text-align: center;
}

.faq-banner-text h1 {
  font-size: 22px;
  margin-bottom: 5px;
  color: black;
}

.faq-banner-text p {
  font-size: 12px;
  color: black;
}

/* Main content */
.faq-content {
  background: #f5f5f5;
  padding: 40px 0 60px;
  text-align: center;
}

.faq-heading {
  color: #1a73e8;
  font-size: 14px;
  margin-bottom: 35px;
}

/* Grid layout */
.faq-grid {
  display: grid;
  grid-template-columns: repeat(2, 500px);
  justify-content: center;
  column-gap: 120px;
  row-gap: 40px;
}

/* Column */
.faq-column {
  text-align: left;
}

.faq-column h4 {
  font-size: 13px;
  margin-bottom: 10px;
  font-weight: 600;
}

/* List */
.faq-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.faq-column li {
  font-size: 14px;
  padding: 8px 0;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Plus icon */
.faq-column li span {
  font-size: 14px;
  color: #555;
  cursor: pointer;
}


@media (max-width: 768px) {
  .faq-banner {
    height: 160px;
  }

  .faq-banner-text h1 {
    font-size: 18px;
    color: white;
  }

  .faq-banner-text p {
    font-size: 11px;
    color: white;
  }

  .faq-content {
    padding: 25px 15px 40px;
  }

  .faq-heading {
    font-size: 13px;
    margin-bottom: 25px;
  }

  .faq-grid {
    grid-template-columns: 1fr;
    column-gap: 0;
    row-gap: 25px;
    padding: 0 10px;
  }

  .faq-column {
    width: 100%;
  }

  .faq-column h4 {
    font-size: 14px;
    margin-bottom: 8px;
  }

  .faq-column li {
    font-size: 13px;
    padding: 10px 0;
  }

  .faq-column li span {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/FAQ/faq.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,WAAW;EACX,YAAY;AACd;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,uCAAuC;EACvC,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;AACf;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;;AAGA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,aAAa;IACb,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Container */\n.faq-container {\n  width: 100%;\n  color: black;\n}\n\n/* Banner */\n.faq-banner {\n  position: relative;\n  height: 220px;\n  overflow: hidden;\n}\n\n.faq-banner-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: brightness(55%);\n}\n\n.faq-banner-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: white;\n  text-align: center;\n}\n\n.faq-banner-text h1 {\n  font-size: 22px;\n  margin-bottom: 5px;\n  color: black;\n}\n\n.faq-banner-text p {\n  font-size: 12px;\n  color: black;\n}\n\n/* Main content */\n.faq-content {\n  background: #f5f5f5;\n  padding: 40px 0 60px;\n  text-align: center;\n}\n\n.faq-heading {\n  color: #1a73e8;\n  font-size: 14px;\n  margin-bottom: 35px;\n}\n\n/* Grid layout */\n.faq-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 500px);\n  justify-content: center;\n  column-gap: 120px;\n  row-gap: 40px;\n}\n\n/* Column */\n.faq-column {\n  text-align: left;\n}\n\n.faq-column h4 {\n  font-size: 13px;\n  margin-bottom: 10px;\n  font-weight: 600;\n}\n\n/* List */\n.faq-column ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.faq-column li {\n  font-size: 14px;\n  padding: 8px 0;\n  border-bottom: 1px solid #ddd;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n/* Plus icon */\n.faq-column li span {\n  font-size: 14px;\n  color: #555;\n  cursor: pointer;\n}\n\n\n@media (max-width: 768px) {\n  .faq-banner {\n    height: 160px;\n  }\n\n  .faq-banner-text h1 {\n    font-size: 18px;\n    color: white;\n  }\n\n  .faq-banner-text p {\n    font-size: 11px;\n    color: white;\n  }\n\n  .faq-content {\n    padding: 25px 15px 40px;\n  }\n\n  .faq-heading {\n    font-size: 13px;\n    margin-bottom: 25px;\n  }\n\n  .faq-grid {\n    grid-template-columns: 1fr;\n    column-gap: 0;\n    row-gap: 25px;\n    padding: 0 10px;\n  }\n\n  .faq-column {\n    width: 100%;\n  }\n\n  .faq-column h4 {\n    font-size: 14px;\n    margin-bottom: 8px;\n  }\n\n  .faq-column li {\n    font-size: 13px;\n    padding: 10px 0;\n  }\n\n  .faq-column li span {\n    font-size: 13px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
